<template>
  <div class="testGroup app-container" v-loading="loading">
    <div class="global-header-wrap">
      <h3>测试组管理</h3>
      <div class="testGroup-header-right">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'testGroupAdd' })"
        >
          新增
        </button>
      </div>
    </div>
    <div class="testGroup-main">
      <el-card class="app-table-container" :body-style="{ padding: '20px' }">
        <!-- <div slot="header">
        <div class="global-table-header">
          <div class="testGroup-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchFun" />
          </div>
        </div>
      </div> -->
        <div class="global-body-wrap">
          <TableView
            :tableData="tableData"
            :tableProp="tableProp"
            handleWidth="200"
            :handleBtn="handleBtn"
            @tableHandle="tableHandle"
          />
        </div>
        <Pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="getPageNum"
        />
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import listSearch from '@/components/listSearch'
import TableView from '@/components/tableView'
import Pagination from '@/components/pagination'
export default {
  components: {
    listSearch,
    TableView,
    Pagination
  },
  computed: {
    tableProp() {
      let tableProp = [
        {
          prop: 'name',
          label: '标题'
        },
        {
          prop: 'macs',
          label: 'Macs'
        },
        {
          prop: 'createdAt',
          label: '创建时间'
        }
      ]
      return tableProp
    },
    handleBtn() {
      return [
        { style: 'checkDetailsBtn', type: 'edit', title: '编辑' },
        { style: 'delBtn', type: 'del', title: '删除' }
      ]
    }
  },
  data() {
    return {
      loading: false,
      params: {
        limit: 20,
        page: 1
      },
      tableData: [],
      total: 0,
      currentItem: null
    }
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        let res = await this.$http.getMacGroups(this.params)
        this.tableData = res.data.results
        this.total = res.data.count
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    tableHandle({ type, data }) {
      this.currentItem = data
      switch (type) {
        case 'edit':
          this.$router.push({
            name: 'testGroupAdd',
            query: { id: this.currentItem._id }
          })
          break
        case 'del':
          this.del()
          break

        default:
          break
      }
    },

    async del() {
      await this.$confirm('将删除此项配置', '确定删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        center: true
      })
      try {
        await this.$http.delMacGroups(this.currentItem._id)
        this.getList()
        this.$message({
          type: 'success',
          message: this.$t('commonMsg.success')
        })
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t('commonMsg.failure')
        })
      }
    },

    listSearchFun(val) {
      if (val) {
        this.params.name = val
      } else {
        delete this.params.name
      }
      this.getList()
    },

    getPageNum(page) {
      this.params.page = page
      this.getList()
    }
  },

  mounted() {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.testGroup {
  .testGroup-main {
    flex: 1;
    display: flex;
    overflow: hidden;
    .testGroup-main-left {
      margin: 20px 0 20px 20px;
      width: 250px;
      display: flex;
      flex-direction: column;
      .testGroup-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      > .el-card__body {
        flex: 1;
        display: flex;
        overflow: hidden;
      }
      .testGroup-menu {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .testGroup-menu-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;
          padding: 10px;
          cursor: pointer;
          > p {
            flex: 1;
          }
          &:hover {
            background: #f3f6f9;
            > .testGroup-btn {
              display: block;
            }
          }
          .testGroup-btn {
            display: none;
            > i {
              margin-left: 10px;
            }
          }
        }
        .menuActive {
          background: #f3f6f9;
        }
      }
    }
  }
}
</style>
